








































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Typography } from '@/components/atoms';

import eventBus from '@/utils/eventBus';
import flagKeys from '@/constants/flagKeys';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import SellCoinsPurchaseHistory from '@/componentsV2/templates/SellCoinsPurchaseHistory/SellCoinsPurchaseHistory.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import InfoIcon from '@/components/icons/Info.vue';

import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';

import BusinessWalletService from '@/api/BusinessWalletService';
import BusinessPayoutService from '@/api/BusinessPayoutService';

import { BusinessWalletDashboard } from '@/api/interfaces/business-wallet-dashboard.interface';
import { BusinessPayoutMethod } from '@/api/interfaces/business-payout-withdraw.interface';

import BannerActivateBilling from '@/components/molecules/BannerActivateBilling/BannerActivateBilling.vue';
import BannerReactiveBilling from '@/components/molecules/BannerReactiveBilling/BannerReactiveBilling.vue';
import { BreadcrumbData } from '@/componentsV2/molecules/Breadcrumbs/Breadcrumbs.vue';

import { EBillingStatusTypes } from '@/store/modules/businessTypes';

import isMobile from '@/utils/mobile-check';
import BillingModel from '@/views/Models/BillingModel.vue';

@Component({
  components: {
    Typography,
    Page,
    SellCoinsPurchaseHistory,
    BannerActivateBilling,
    BannerReactiveBilling,
    FilledButton,
    InfoIcon
  }
})
export default class PurchaseHistory extends BillingModel {
  @Prop() onUpdate!: any;

  dashboardData: BusinessWalletDashboard | null = null;
  businessWalletService: BusinessWalletService = new BusinessWalletService();

  loading: boolean = false;
  sidebarPosition: 'relative' | 'sticky' = 'relative';

  withdrawLoading: boolean = false;
  businessPayoutService = new BusinessPayoutService();

  campaignId: string = '';
  campaignName: string = '';

  get isMobileDevice() {
    return isMobile();
  }

  get tPrefix() {
    return 'sellCoins.overview';
  }

  get title() {
    return this.campaignId ? 'Sell Coins' : 'Purchase history';
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get tooltipText() {
    return String(this.$t(`${this.tPrefix}.cards.withdraw.tooltip`));
  }

  get welcomeCtaText() {
    return 'Explore Sell Coins';
  }

  get showActivateBillingBanner() {
    return !this.loading && this.inactiveBilling;
  }

  get toBeCanceledBilling() {
    if (!this.flags.includes(flagKeys.billingModuleV2)) return false;

    return this.billingStatus === EBillingStatusTypes.TO_BE_CANCELED;
  }

  createObserver() {
    const target: HTMLElement = this.$refs.target as HTMLElement;

    if (this.isMobileDevice) return;

    const observer = new IntersectionObserver(async entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.sidebarPosition = 'relative';
        } else {
          this.sidebarPosition = 'sticky';
        }
      });
    });

    if (target) {
      observer.observe(target);
    }
  }

  back() {
    this.$router.push('/sell-coins');
  }

  get breadcrumbs() {
    const breadcrumbList: BreadcrumbData[] = [
      {
        label: 'Overview',
        path: '/sell-coins'
      },
      {
        label: this.campaignName || 'Purchase History'
      }
    ];

    return breadcrumbList;
  }

  async fetchDashboardData() {
    this.loading = true;

    try {
      const { data } = await this.businessWalletService.getDashboard();
      this.dashboardData = data;
    } finally {
      this.loading = false;
    }
  }

  get balanceAmount() {
    return this.getDataOptional('formatted.balance.available', '--');
  }

  get balanceBeingProcessed() {
    return this.getDataOptional('coins.sold.diffFromLastMonth')
      ? String(
          `${this.getDataOptional('coins.sold.diffFromLastMonth') ||
            0}% ${this.$t(`${this.tPrefix}.cards.coins.insight`)}`
        )
      : '';
  }

  getDataOptional(path: string, fallbackValue: any = false) {
    return (
      path
        .split('.')
        .reduce(
          (a: any, v) => (!!a && typeof a === 'object' ? a[v] : null),
          this.dashboardData || {}
        ) || fallbackValue
    );
  }

  goBack() {
    this.$router.back();
  }

  get isWithdrawDisabled() {
    return (
      this.dashboardData &&
      (this.dashboardData.balance.available <= 0 ||
        !this.dashboardData.balance.passedWithdrawCommonValidations)
    );
  }

  async openWithdrawModal() {
    this.withdrawLoading = true;

    const { data } = await this.businessPayoutService.getWithdrawDetails({
      method: BusinessPayoutMethod.STANDARD
    });

    this.withdrawLoading = false;

    if (!data) {
      return;
    }

    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        icon: 'none',
        hideCancelButton: true,
        confirmEvent: '',
        componentToRender: 'withdrawSellCoins'
      }),
      {
        data,
        onConfirm: async () => {
          if (this.onUpdate) {
            this.onUpdate();
          }
        }
      }
    );
  }

  created() {
    this.campaignId = (this.$route.query.id as string) || '';
    this.campaignName = (this.$route.query.name as string) || '';
  }

  mounted() {
    this.createObserver();
    this.fetchDashboardData();
  }
}
